import { render, staticRenderFns } from "./confirm-send-message-modal.vue?vue&type=template&id=1d1549f5&"
import script from "./confirm-send-message-modal.vue?vue&type=script&lang=js&"
export * from "./confirm-send-message-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports